module.exports = __webpack_public_path__ + "img/error-icon.b69781a2.svg";